<template>
  <div class="dlistnum_con column">
    <div class="fifth">
      <div class="issue_year">年度期数</div>
      <div ref="len2">
        <div v-loading="loading" style="margin-top: 20px">
          <template v-for="(item, b) in Year">
            <div v-if="b < num" class="Issueline">
              <div class="highblue leftfloat year_issue">
                <div>{{ item.PublishYear }}</div>
                <div>（{{ item.Volume }}卷）</div>
              </div>

              <div class="leftfloat ml15 volum_issue">
                <ul>
                  <li
                    class="issue_directory"
                    v-for="(uitem, c) in item.Issue"
                    :key="c"
                  >
                    <a @click="tomouthgzh(uitem.IssueId)" v-if="isgzh">
                      <p>{{ uitem.IssueNum }}</p>
                    </a>

                    <a @click="tomouth(uitem.IssueId)" v-else>
                      <p>{{ uitem.IssueNum }}</p>
                    </a>
                    <p title="出版日期">{{ uitem.Publish_Date }}</p>
                  </li>
                </ul>
              </div>

              <div class="clearfix"></div>
            </div>
          </template>
        </div>
        <a
          href="javascript:;"
          @click="opena2"
          ref="openp2"
          style="cursor: pointer"
          >展开</a
        >
      </div>
    </div>
    <div class="fifth" v-if="Column != null && Column.length > 0">
      <div class="issue_year" ref="menu">栏目目录</div>
      <div v-loading="loading" style="margin-top: 20px">
        <ul
          class="Column_list"
          ref="len1"
          style="height: 80px; overflow: hidden"
        >
          <li
            v-for="(item, a) in Column"
            :ref="getRefSetter('lenli1')"
            :key="a"
            @click="tomoutha(item.ItemID, 'Column')"
          >
            <a
              >{{ item.ItemName }}(<span class="red">{{ item.Count }}</span
              >)</a
            >
          </li>
        </ul>
        <div class="clearfix"></div>
        <a
          href="javascript:;"
          @click="opena1"
          ref="openp1"
          style="cursor: pointer"
          v-if="Column.length > 12"
          >展开</a
        >
      </div>
    </div>
    <div class="fifth" v-if="Field != null && Field.length > 0">
      <div class="issue_year" ref="menu">领域目录</div>
      <div v-loading="loading" style="margin-top: 20px">
        <ul
          class="Column_list"
          ref="len"
          style="height: 80px; overflow: hidden"
        >
          <li
            v-for="(item, i) in Field"
            :ref="getRefSetter('lenli')"
            :key="i"
            @click="tomoutha(item.ItemID, 'Field')"
          >
            <a
              >{{ item.ItemName }}(<span class="red">{{ item.Count }}</span
              >)</a
            >
          </li>
        </ul>
        <div class="clearfix"></div>
        <a
          href="javascript:;"
          @click="opena"
          ref="openp"
          style="cursor: pointer"
          v-if="Field.length > 12"
          >展开</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Year: [],
      Column: [],
      title: "",
      Field: [],
      islingyu: false,
      islanmu: false,
      num: "",
      loading: true,
      isgzh: 0,
      Number: "",
    };
  },

  mounted() {
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map((item) => {
        if (item.SetItemID == 1000) {
          this.title = item.Item_Value;
        }
        if (item.SetItemID == 99) {
          if (item.Item_Value == "是") {
            this.islingyu = true;
          } else {
            this.islingyu = false;
          }
        }
        if (item.SetItemID == 96) {
          if (item.Item_Value == "是") {
            this.islanmu = true;
          } else {
            this.islanmu = false;
          }
        }
        if (item.SetItemID == 4554) {
          this.num = item.Item_Value;
        }
      });
      this.getmenu();
    } else {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 2960, 4553,
        310, 4554,
      ];
      //1000:期刊名称
      //1001：期刊英文名称
      //4530：（否）隐藏/（是）显示预出版模块
      //6018:预出版模块显示 （否）文章列表/（是）预出版内容
      //6019：是否需要登录下载文件
      //230：显示/隐藏所有的评论功能
      //6055：显示/隐藏列表和详情页的英文标题，英文关键字，英文摘要
      //5000： ISSN编号
      //5010：CN编号
      this.$store.dispatch("_getSet", params).then((res) => {
        sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
        let SetItem = res.data.Data;
        SetItem.map((item) => {
          if (item.SetItemID == 1000) {
            this.title = item.Item_Value;
          }
          if (item.SetItemID == 99) {
            if (item.Item_Value == "是") {
              this.islingyu = true;
            } else {
              this.islingyu = false;
            }
          }
          if (item.SetItemID == 96) {
            if (item.Item_Value == "是") {
              this.islanmu = true;
            } else {
              this.islanmu = false;
            }
          }
          if (item.SetItemID == 4554) {
            this.num = item.Item_Value;
          }
        });

        this.getmenu();
      });
    }
  },

  watch: {
    num(o, l) {
      console.log(o, l);
      this.Number = l;
    },
  },

  methods: {
    getmenu() {
      this.$store
        .dispatch("_getgok")
        .then((res) => {
          if (res.data.IsSuccess) {
            this.loading = false;
            this.Year = res.data.Data.Year;

            if (this.islingyu == true) {
              this.Field = res.data.Data.Field;
            } else {
              this.Field = [];
            }
            if (this.islanmu == true) {
              this.Column = res.data.Data.Column;
            } else {
              this.Column = [];
            }
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    tomouth(id, type) {
      this.$router.push({
        path: "/OAList",
        query: { IssueId: id },
      });
    },
    tomouthgzh(id, type) {
      this.$router.push({
        path: "/gzhOAList",
        query: { IssueId: id },
      });
    },
    tomoutha(id, type) {
      this.$router.push({
        path: "/FieldColumnList?IssueId=" + id + "&type=" + type,
        query: { IssueId: id, type: type },
      });
    },
    opena() {
      if (this.$refs.openp.innerText === "展开") {
        this.$refs.len.style.height = "";
        this.$refs.openp.innerText = "收缩";
      } else {
        this.$refs.len.style.height = 80 + "px";
        this.$refs.openp.innerText = "展开";
      }
    },
    opena1() {
      if (this.$refs.openp1.innerText === "展开") {
        this.$refs.len1.style.height = "";
        this.$refs.openp1.innerText = "收缩";
      } else {
        this.$refs.len1.style.height = 80 + "px";
        this.$refs.openp1.innerText = "展开";
      }
    },
    opena2() {
      if (this.$refs.openp2.innerText === "展开") {
        // this.$refs.len2.style.height = ''
        this.num = this.Year.length;
        this.$refs.openp2.innerText = "收缩";
      } else {
        // this.$refs.len2.style.height = 380 + 'px'
        this.num = this.Number;
        this.$refs.openp2.innerText = "展开";
      }
    },
    getRefSetter(refKey) {
      return (ref) => {
        !this.$arrRefs && (this.$arrRefs = {});
        !this.$arrRefs[refKey] && (this.$arrRefs[refKey] = []);
        ref && this.$arrRefs[refKey].push(ref);
      };
    },
  },

  beforeUpdate() {
    this.$arrRefs && (this.$arrRefs = {});
  },
};
</script>

<style scoped>
ul li a {
  cursor: pointer;
}
</style>
